import commonService from "./common-service";

class MARPrintServices {
    async getMARPatientsBySearch(query) {
        try {
            const response = await commonService.getFromServer("PrintLabel/GetActiveOrderPatientList?" + query, {});
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getMARPatientActiveOrderList(pat_id) {
        try {
            const response = await commonService.getFromServer("PrintLabel/GetPatientActiveOrderList?pat_id=" + pat_id, {});
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getMARPrintLabelText(item) {
        try {
            const response = await commonService.postToServer("PrintLabel/GetLabelText", item);
            if (response) {
                return response;
            } else {
                throw new Error("Error loading carriers");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }
}

export default new MARPrintServices();